import React from 'react';
import { isListingTimedEntryCheckoutExperimentEnabled } from '../../experimentation';

interface IListingTimedEntryExperimentContext {
    isListingTimedEntryExperimentActive: boolean;
}

interface IListingTimedEntryExperimentContextProviderProps {
    sessionsLength: number;
    seriesInfiniteCalendarSplitFF: boolean;
    parentEventId: string | undefined;
}

const ListingTimedEntryExperimentContext =
    React.createContext<IListingTimedEntryExperimentContext>(
        {} as IListingTimedEntryExperimentContext,
    );

export const useListingTimedEntryExperimentContext = () => {
    const context = React.useContext(ListingTimedEntryExperimentContext);
    if (!context) {
        throw new Error(
            'useListingTimedEntryExperimentContext must be used within ListingTimedEntryExperimentContext',
        );
    }
    return context;
};

export const ListingTimedEntryExperimentContextProvider: React.FC<
    IListingTimedEntryExperimentContextProviderProps
> = ({
    sessionsLength,
    seriesInfiniteCalendarSplitFF,
    parentEventId,
    children,
}) => {
    const isExperimentActive = isListingTimedEntryCheckoutExperimentEnabled(
        sessionsLength,
        seriesInfiniteCalendarSplitFF,
        parentEventId,
    );

    return (
        <ListingTimedEntryExperimentContext.Provider
            value={{
                isListingTimedEntryExperimentActive: isExperimentActive,
            }}
        >
            {children}
        </ListingTimedEntryExperimentContext.Provider>
    );
};
